import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { log } from 'core/utilities';
import { HelmetProvider } from 'react-helmet-async';

// Some older Webpack 4-era dependencies expect a Node-like `process` global.
// In modern browsers it may be missing, which can hard-crash the app at runtime.
(window as any).process = (window as any).process ?? { env: {} };

ReactDOM.render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

reportWebVitals(log.webVitals);
